/**
 * This file contains a common initialization logic used in the web-app as well
 * as in Storybook.
 */

import { initializeIcons } from '@fluentui/react';
import '@h2oai/ui-kit/lib/assets/css/include-inter.css';
import '@h2oai/ui-kit/lib/assets/css/variables.css';
import './index-legacy.css';

// loads the fonts from `public/fonts` directory
initializeIcons(`/fonts/`);
